





































































































import {
  Component, mapState, Watch, mixins,
} from '@samclick-commons';
import SamclickMixins from '@/utils/mixins';
import {
  CommonsStore, AdvertisementsStore, Payload, AuthorizationStore,
} from '@samclick-store-factory';
import AdsDetail from './AdsDetail.vue';

// No longer need _includes from lodash
// import { _includes } from '@samclick-lodash';

class AdvertisementState {
  public casinoID: string | number = ''
  public width: string | number = ''
  public height: string | number = ''
  public category: string | number = ''
  // --- CHANGED ---: Renamed and changed type from Array<string> to string
  public bannerType: string = ''
  public country: any
}

// ... AlternateMarketCasino and Pagination classes are unchanged ...
class AlternateMarketCasino {
  public isAlternateMarketCasino: boolean = false
  public casinoID: string | number = ""
}

class Pagination {
  pageIndex: number = 1
  pageSize: number = 10
}


@Component({
  components: { AdsDetail },
  computed: {
    ...mapState({
      adsType: (state: any) => state.commons.commonsStore.adsType,
      adsList: (state: any) => state.advertisements.advertisementsStore.ads,
      adsTotal: (state: any) => state.advertisements.advertisementsStore.adsTotal,
      campaignList: (state: any) => state.advertisements.advertisementsStore.campaignList,
      loading: (state: any) => state.advertisements.advertisementsStore.loading,
    }),
  },
  props: {},
})
export default class Advertisement extends mixins(SamclickMixins) {
  state = new AdvertisementState();
  pagination = new Pagination()

  SamclickButton = new SamclickMixins().$data.SamclickButton
  SamclickNumber = new SamclickMixins().$data.SamclickNumber

  ACTIVE = 1;
  adsList!: [];
  adsTotal!: number;

  mediaTypes = [
    { id: '16', name: 'Banners' },
    { id: '2', name: 'Text Links' },
    { id: '4', name: 'Image Links' },
    { id: '8', name: 'Email Templates' },
  ];

  // --- CHANGED ---: Watcher now observes 'state.bannerType'
  @Watch('state.bannerType')
  sampleWatcher(newVal: string) {
    if (!this.isContainsBannerFlow(newVal)) {
      this.state.width = '';
      this.state.height = '';
    }
  }

  @Watch('state.casinoID')
  onCasinoChange() {
    if (!this.state.country) {
      return;
    }
    const allowedCountries = this.countriesForFilter;
    if (!this.isCountryAllowed(this.state.country, allowedCountries)) {
      this.state.country = '';
    }
  }

  search() {
    // --- CHANGED ---: Destructuring bannerType instead of bannerTypes
    const {
      casinoID, width, height, bannerType, category, country,
    } = this.state;

    AdvertisementsStore.getAdsList(new Payload({
      casino_id: casinoID,
      // --- CHANGED ---: Passing bannerType directly
      banner_type: bannerType,
      width,
      height,
      page_no: this.pagination.pageIndex,
      page_size: this.pagination.pageSize,
      category_id: category,
      country: country,
    }));
    AdvertisementsStore.getCampaignList(new Payload({ affiliateId: AuthorizationStore.currentLoggedUserInState.id, status: 1 }));
  }

  get countriesForFilter() {
      const countries = CommonsStore.activeMarketCountries || [];
      const activeCountries = countries.filter(country => country.is_active === true);

      if (!this.state.casinoID) {
          return activeCountries;
      }

      const selectedCasino = this.enabledCasinos.find(
        (casino: any) => String(casino.id) === String(this.state.casinoID),
      );
      if (!selectedCasino) {
        return activeCountries;
      }
      const assignedCountries = this.collectCountriesFromCasino(selectedCasino);
      const matchSets = this.buildCountryMatchSets(assignedCountries);

      return activeCountries.filter((country: any) => {
          const countryId = country.id !== undefined && country.id !== null ? String(country.id) : null;
          const countryCode = country.country_code ? String(country.country_code) : null;
          return (countryId && matchSets.ids.has(countryId))
              || (countryCode && matchSets.codes.has(countryCode));
      });
  }

  reset() {
    this.state = new AdvertisementState();
    AdvertisementsStore.destroyAdvertisementsTable();
    this.search();
  }

  handleSizeChange(newPageSize: number) {
    this.pagination.pageSize = newPageSize;
    this.search();
  }

  handleCurrentChange(newPageIndex: number) {
    this.pagination.pageIndex = newPageIndex;
    this.search();
  }

  get enabledCasinos() {
    return CommonsStore.enabledCasinos;
  }

  get filteredEnabledCasinos() {
    if (!this.state.country || this.state.casinoID) {
      return this.enabledCasinos;
    }

    const selectedCountry = this.getSelectedCountryMatch(this.state.country);

    return this.enabledCasinos.filter((casino: any) => {
      const assignedCountries = this.collectCountriesFromCasino(casino);
      return this.matchesSelectedCountry(assignedCountries, selectedCountry);
    });
  }

  get getAllAdvertisementCategories() {
    return CommonsStore.allAdvertisementCategories;
  }

  // --- CHANGED ---: Method now compares the string directly
  isContainsBannerFlow(type: string) {
    return type === '16' || type === '4';
  }

  private collectCountriesFromCasino(casino: any): any[] {
    if (!casino) {
      return [];
    }

    const countries: any[] = [];
    const pushCountries = (list: any) => {
      if (Array.isArray(list)) {
        countries.push(...list);
      }
    };

    pushCountries(casino.countries);
    pushCountries(casino.market_countries);
    pushCountries(casino.marketCountries);

    if (Array.isArray(casino.markets)) {
      casino.markets.forEach((market: any) => {
        pushCountries(market.countries);
        pushCountries(market.market_countries);
        pushCountries(market.marketCountries);
      });
    }

    return countries;
  }

  private buildCountryMatchSets(countries: any[]) {
    const ids = new Set<string>();
    const codes = new Set<string>();

    countries.forEach((country: any) => {
      const id = country
        ? (country.id !== undefined && country.id !== null ? country.id
          : (country.country_id !== undefined && country.country_id !== null ? country.country_id
            : (country.countryId !== undefined && country.countryId !== null ? country.countryId : null)))
        : null;
      const code = country
        ? (country.country_code ? country.country_code
          : (country.code ? country.code
            : (country.countryCode ? country.countryCode : null)))
        : null;
      if (id !== undefined && id !== null) {
        ids.add(String(id));
      }
      if (code) {
        codes.add(String(code));
      }
    });

    return { ids, codes };
  }

  private getSelectedCountryMatch(country: any) {
    if (country && typeof country === 'object') {
      const id = country.id !== undefined && country.id !== null ? country.id
        : (country.country_id !== undefined && country.country_id !== null ? country.country_id
          : (country.countryId !== undefined && country.countryId !== null ? country.countryId : null));
      const code = country.country_code ? country.country_code
        : (country.code ? country.code
          : (country.countryCode ? country.countryCode : null));
      return { id, code };
    }

    return { id: country, code: null };
  }

  private matchesSelectedCountry(countries: any[], selected: { id: any; code: any }) {
    if (!selected || (selected.id === null && !selected.code)) {
      return false;
    }
    const matchSets = this.buildCountryMatchSets(countries);
    if (selected.id !== undefined && selected.id !== null) {
      return matchSets.ids.has(String(selected.id));
    }
    if (selected.code) {
      return matchSets.codes.has(String(selected.code));
    }
    return false;
  }

  private isCountryAllowed(selectedCountry: any, allowedCountries: any[]) {
    if (!selectedCountry) {
      return false;
    }
    const selectedMatch = this.getSelectedCountryMatch(selectedCountry);
    if (selectedMatch.id === null && !selectedMatch.code) {
      return false;
    }
    return allowedCountries.some((country: any) => {
      const countryId = country.id !== undefined && country.id !== null ? String(country.id) : null;
      const countryCode = country.country_code ? String(country.country_code) : null;
      if (selectedMatch.id !== null && selectedMatch.id !== undefined && countryId) {
        return countryId === String(selectedMatch.id);
      }
      if (selectedMatch.code && countryCode) {
        return countryCode === String(selectedMatch.code);
      }
      return false;
    });
  }

  created() {
    this.search();
  }

  mounted() {
      CommonsStore.fetchAllMarketCountries();
  }
}
